import { render, staticRenderFns } from "./UiAccordion.vue?vue&type=template&id=72c6708c&scoped=true&"
import script from "./UiAccordion.vue?vue&type=script&lang=js&"
export * from "./UiAccordion.vue?vue&type=script&lang=js&"
import style0 from "./UiAccordion.vue?vue&type=style&index=0&id=72c6708c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c6708c",
  null
  
)

export default component.exports